var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessOffer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 575,
    height: 474.932,
    viewBox: "0 0 575 474.932",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e7a9d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c5c3ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#caceea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 0.498,
    x2: 1,
    y2: 0.498,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f28ac0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0658a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.419,
    y1: -0.106,
    x2: 0.568,
    y2: 1.093,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#131e44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#111761"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "business-offer",
    transform: "translate(-0.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M2.09,197.089s8.992,16.04,83.3,7.2,14.268-19.351,14.268-19.351S-16.684,175.261,2.09,197.089Z",
    transform: "translate(-0.04 207.635)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M58.515,228.793s73.388,54.529,413.7,18.176c0,0,86.31-6.813,55.169-30.308s-197.589-16.745-197.589-16.745-38.146-13.605-114.354-8.373-92.419-8.928-132.68,3.247S14.153,217.9,58.515,228.793Z",
    transform: "translate(40.845 215.467)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 82.551,
    height: 156.046,
    transform: "translate(481.551 237.337)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 82.551,
    height: 156.046,
    transform: "translate(457.053 237.337)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M287.507,139.313H216.66V114.58h70.847Zm-69.971-.876h69.1V115.477h-69.1Z",
    transform: "translate(246.01 130.147)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M227.214,114.78H254.1a4.934,4.934,0,0,1-4.934,4.934H232.084a4.934,4.934,0,0,1-4.934-4.934h.064Z",
    transform: "translate(257.926 130.374)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M287.507,154.023H216.66V129.29h70.847Zm-69.971-.876h69.1V130.166h-69.1Z",
    transform: "translate(246.01 146.856)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M227.214,129.5H254.1a4.934,4.934,0,0,1-4.934,4.934H232.084a4.934,4.934,0,0,1-4.934-4.934h0Z",
    transform: "translate(257.926 147.094)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M287.507,168.733H216.66V144h70.847Zm-69.971-.854h69.1v-23h-69.1Z",
    transform: "translate(246.01 163.564)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M227.214,144.21H254.1a4.934,4.934,0,0,1-4.934,4.934H232.084a4.934,4.934,0,0,1-4.934-4.934h.064Z",
    transform: "translate(257.926 163.803)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M287.507,183.443H216.66V158.71h70.847Zm-69.971-.854h69.1v-23h-69.1Z",
    transform: "translate(246.01 180.273)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M227.214,158.92H254.1a4.934,4.934,0,0,1-4.934,4.934H232.084a4.934,4.934,0,0,1-4.934-4.934h0Z",
    transform: "translate(257.926 180.511)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 89.664,
    height: 7.775,
    transform: "translate(453.401 231.506)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 26.955,
    height: 7.775,
    transform: "translate(543.043 231.506)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 4.336,
    height: 7.967,
    transform: "translate(457.053 393.383)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 4.336,
    height: 7.967,
    transform: "translate(483.858 393.383)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 4.336,
    height: 7.967,
    transform: "translate(532.812 393.383)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 4.336,
    height: 7.967,
    transform: "translate(557.289 393.383)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M237.794,98.58l8.351,21.38-5.19-.021L236.79,106.8Z",
    transform: "translate(268.875 111.973)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M225.422,89.34l-2.862,40.945,29.646.619,3.332-41.564Z",
    transform: "translate(252.712 101.478)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M226.562,90.994l-2.392,34.088,22.042,1.047,3.076-35.349Z",
    transform: "translate(254.541 103.114)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M228.493,93.14,226.72,117.1h12.153l2.136-23.964Z",
    transform: "translate(257.437 105.794)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M252.124,123.881s-6.408-.47-5.745,13.734a163.572,163.572,0,0,0,2.136,21.786s-.171,3.14-2.627,2.52-7.027-3.674-9.291-1.388-1.516,6.023,1.6,10.316,9.611,13.947,10.188,14.823.812,2.478-.918,2.328-13.413-4.122-14.951,1.538,9.1,16.19,10.252,17.365,1.2,1.9.726,2.606-4.272-.983-7.625-1.965-7.433-1.559-8.052,1.794,4.079,13.093,21.636,23.345L258,236.954l8.009-5.1c16.446-11.961,20.141-22.149,19.223-25.417s-4.934-2.285-8.18-.961-6.877,3.4-7.411,2.734-.534-1.41.491-2.691,10.551-12.815,8.543-18.3-13.328-.363-14.951,0-1.623-1.3-1.153-2.136,5.98-11.192,8.543-15.763,3.14-8.309.577-10.423-6.749,1.452-9.12,2.307-2.862-2.264-2.862-2.264a165.466,165.466,0,0,0-.15-21.871c-.854-14.182-7.262-13.029-7.262-13.029",
    transform: "translate(258.625 140.71)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M239.41,129.83a1.693,1.693,0,0,1,0,.3V131c0,.79.128,1.9.214,3.353.192,2.926.449,7.134.726,12.345.6,10.423,1.26,24.84,1.965,40.752s1.324,30.329,1.858,40.752c.256,5.212.47,9.419.619,12.367,0,1.431.128,2.563.171,3.353v0c0-.79-.128-1.9-.235-3.353-.192-2.9-.427-7.134-.726-12.345-.577-10.423-1.26-24.84-1.944-40.752s-1.346-30.329-1.858-40.752c-.278-5.212-.491-9.419-.641-12.367,0-1.431-.128-2.563-.15-3.353V129.83Z",
    transform: "translate(271.851 147.469)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M234.781,143.17l.513.449c.342.278.79.726,1.346,1.282,1.111,1.111,2.627,2.67,4.272,4.421l4.122,4.528,1.26,1.367c.3.32.449.513.449.513a3.608,3.608,0,0,1-.534-.427c-.32-.3-.79-.726-1.346-1.3-1.089-1.111-2.584-2.691-4.272-4.443l-4.272-4.507-1.26-1.346C234.909,143.384,234.76,143.191,234.781,143.17Z",
    transform: "translate(266.591 162.621)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M240.76,156.485s3.033-3.289,6.9-7.219,7.07-7.07,7.134-7.006-3.033,3.311-6.9,7.241S240.824,156.656,240.76,156.485Z",
    transform: "translate(273.385 161.587)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M240.74,165.3l.6-.363,1.645-.94c1.41-.79,3.332-1.858,5.4-3.14s3.93-2.5,5.254-3.4l1.581-1.047a2.371,2.371,0,0,1,.6-.342,3.477,3.477,0,0,1-.534.449c-.342.278-.854.662-1.517,1.132-1.3.94-3.118,2.136-5.212,3.481s-4.037,2.328-5.468,3.076l-1.687.833A2.457,2.457,0,0,1,240.74,165.3Z",
    transform: "translate(273.362 177.274)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M234.191,156.38l.577.278c.363.192.9.47,1.538.854,1.282.726,3.054,1.751,5,2.9l4.934,2.99,1.474.94a2.882,2.882,0,0,1,.534.384,1.666,1.666,0,0,1-.6-.278l-1.516-.833-5-2.926-4.955-2.99-1.474-.94C234.362,156.529,234.169,156.4,234.191,156.38Z",
    transform: "translate(265.921 177.626)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M232.89,166.5l.726.363,1.986,1.089c1.645.918,3.909,2.136,6.408,3.674s4.763,2.8,6.408,3.781l1.922,1.175a4.27,4.27,0,0,1,.683.47,5.234,5.234,0,0,1-.748-.363l-1.965-1.089c-1.666-.918-3.93-2.136-6.408-3.7s-4.763-2.777-6.408-3.759l-1.922-1.175a2.67,2.67,0,0,1-.683-.47Z",
    transform: "translate(264.446 189.121)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M241.2,177.8a4.269,4.269,0,0,1,.726-.491l2.136-1.26c1.751-1.047,4.144-2.52,6.728-4.272s4.912-3.268,6.578-4.443l1.965-1.367a5.017,5.017,0,0,1,.748-.47,3.825,3.825,0,0,1-.662.577l-1.922,1.452c-1.623,1.217-3.93,2.841-6.536,4.528s-5,3.14-6.771,4.144c-.876.491-1.6.9-2.136,1.153A3.653,3.653,0,0,1,241.2,177.8Z",
    transform: "translate(273.885 187.985)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M259.588,178.09H236.2l7.625,57.775h8.116Z",
    transform: "translate(268.205 202.286)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M236.77,182.738v.192a1.665,1.665,0,0,0,.577.406,2.9,2.9,0,0,0,2.478-.3,20.464,20.464,0,0,1,3.012-2.008,6.792,6.792,0,0,1,4.272,0,18.754,18.754,0,0,1,3.994,1.944,28.06,28.06,0,0,0,3.268,1.751,9.31,9.31,0,0,0,2.392.7h.918a12.816,12.816,0,0,1-3.2-.961,35.719,35.719,0,0,1-3.183-1.815,18.157,18.157,0,0,0-4.079-2.008,6.856,6.856,0,0,0-4.528,0,5.682,5.682,0,0,0-1.709,1.068c-.491.384-.918.748-1.346,1.025a2.8,2.8,0,0,1-2.285.406A2.372,2.372,0,0,1,236.77,182.738Z",
    transform: "translate(268.853 204.751)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M237.174,188.66a7.12,7.12,0,0,1,.534-.619,5.276,5.276,0,0,1,1.88-1.2,8.736,8.736,0,0,1,3.247-.491,34.333,34.333,0,0,1,4.08.555,13.179,13.179,0,0,0,4.272.171,11.428,11.428,0,0,0,3.268-.918,10.23,10.23,0,0,0,1.965-1.175,3.12,3.12,0,0,0,.641-.577,22.218,22.218,0,0,1-2.713,1.5,12.262,12.262,0,0,1-3.2.833,14.951,14.951,0,0,1-4.079-.192,29.623,29.623,0,0,0-4.1-.534,8.372,8.372,0,0,0-3.375.6,4.934,4.934,0,0,0-1.88,1.324,2.994,2.994,0,0,0-.342.513C237.174,188.575,237.152,188.639,237.174,188.66Z",
    transform: "translate(269.303 209.464)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M255.156,189.912a3.31,3.31,0,0,0-.662-.32,6.621,6.621,0,0,0-1.922-.427,13.029,13.029,0,0,0-2.926.171c-1.111.171-2.264.491-3.5.748a14.591,14.591,0,0,1-3.482.384,7.732,7.732,0,0,1-2.755-.6,6.067,6.067,0,0,1-2.136-1.559s0,.256.384.619a5.1,5.1,0,0,0,1.581,1.2,7.838,7.838,0,0,0,2.883.7,15.164,15.164,0,0,0,3.567-.384c1.239-.256,2.392-.577,3.46-.769a14.29,14.29,0,0,1,2.862-.235,13.116,13.116,0,0,1,2.648.47Z",
    transform: "translate(269.989 213.894)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M238.13,193.547a3.588,3.588,0,0,1,2.285-.235,12.2,12.2,0,0,1,2.371.876,8.543,8.543,0,0,0,3.076.854,9.184,9.184,0,0,0,5.6-1.3,7.156,7.156,0,0,0,1.388-1.068,2.562,2.562,0,0,0,.427-.491,22.55,22.55,0,0,1-1.944,1.346,9.675,9.675,0,0,1-5.425,1.132,41.7,41.7,0,0,1-5.446-1.623,3.4,3.4,0,0,0-1.773.171,1.239,1.239,0,0,0-.555.342Z",
    transform: "translate(270.397 218.29)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M238.74,199.715a4.506,4.506,0,0,0,1.965-.384c1.175-.406,2.627-1.3,4.272-1.986a7.26,7.26,0,0,1,2.5-.513,4.058,4.058,0,0,1,3.439,1.709.907.907,0,0,0-.235-.491,2.969,2.969,0,0,0-1.089-1,4.741,4.741,0,0,0-2.136-.555,6.536,6.536,0,0,0-2.627.513c-1.773.7-3.161,1.623-4.272,2.136A6.171,6.171,0,0,1,238.74,199.715Z",
    transform: "translate(271.09 223.185)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M239.28,200.428a4.764,4.764,0,0,0,1.474.491,27.249,27.249,0,0,0,3.716.619,25.944,25.944,0,0,0,3.738.107,6.237,6.237,0,0,0,1.559-.171c0-.128-2.371,0-5.276-.32S239.3,200.321,239.28,200.428Z",
    transform: "translate(271.704 227.642)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 102.052,
    height: 100.257,
    transform: "translate(257.521)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 94.896,
    height: 94.896,
    transform: "translate(261.066 2.734)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 30.949,
    height: 30.949,
    transform: "translate(293.04 34.708)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M41.582,70.57c-5.382.128-8.543,6.279-8.907,11.64s1.175,10.893-.15,16.1c-1.666,6.621-7.433,11.619-9.077,18.283-1.794,7.86,2.841,15.7,3.439,23.751.3,3.909-.384,7.9.534,11.726A14.951,14.951,0,0,0,42.03,163.138a14.951,14.951,0,0,0,13.691-12.174c.961-6.087-2.008-12.367-.7-18.39.961-4.464,4.272-8.373,4.272-12.815,0-5.425-4.272-9.91-5.382-15.229s1.41-10.679,1.559-16.126c.235-9.74-4.144-17.087-13.862-17.728",
    transform: "translate(26.082 80.158)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M35.987,82.47a6.749,6.749,0,0,1,0,.876c0,.6-.107,1.431-.171,2.456-.15,2.136-.384,5.3-.662,9.077-.577,7.668-1.367,18.262-2.136,29.9s-1.431,22.3-1.9,29.9c-.235,3.8-.427,6.877-.555,9.077,0,1.047-.128,1.858-.171,2.478a7.154,7.154,0,0,1,0,.854,4.527,4.527,0,0,1,0-.876v-2.456c.107-2.136.235-5.3.406-9.1.363-7.689.961-18.283,1.751-29.9s1.645-22.277,2.307-29.9c.342-3.78.641-6.877.833-9.056l.256-2.478a4.763,4.763,0,0,1,.043-.854Z",
    transform: "translate(34.411 93.675)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M40.322,149.7h0a17.087,17.087,0,0,0,17.194-17.087V115.53H23.15v17.087A17.087,17.087,0,0,0,40.322,149.7Z",
    transform: "translate(26.21 131.226)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M23.15,119.6s.214,0,.577.363l1.5,1.175,5.318,4.272h-.3l9.91-6.066h0l.171-.107.15.107,9.206,6.087H49.4l5.831-4.272,1.645-1.175a2.394,2.394,0,0,1,.619-.363,3.308,3.308,0,0,1-.534.491L55.4,121.4c-1.474,1.132-3.4,2.648-5.7,4.464h-.278l-9.27-6h.3l-9.974,5.98h-.15l-.128-.107-5.233-4.379-1.431-1.282a3.61,3.61,0,0,1-.384-.47Z",
    transform: "translate(26.21 135.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M23.151,118s.214,0,.577.363l1.5,1.175,5.318,4.272h-.3l9.91-6.087h0l.171-.107.15.107,9.206,6.087H49.4l5.831-4.272L57,118.432a2.391,2.391,0,0,1,.619-.363,3.313,3.313,0,0,1-.619.363l-1.559,1.282c-1.474,1.132-3.4,2.67-5.7,4.464h-.278l-9.27-6h.3l-9.974,5.98h-.15l-.128-.128-5.276-4.272-1.431-1.26A3.368,3.368,0,0,1,23.151,118Z",
    transform: "translate(26.209 133.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M23.151,121.136s.214,0,.577.384l1.5,1.153,5.318,4.272h-.3l9.91-6.066h.171l.15.107,9.206,6.066H49.4l5.831-4.272,1.645-1.153a2.135,2.135,0,0,1,.619-.384,3.31,3.31,0,0,1-.534.491L55.4,123.016l-5.681,4.528-.128.107h-.15l-9.27-6h.3L30.5,127.544h-.15l-.128-.107-5.254-4.443-1.431-1.282C23.3,121.414,23.13,121.243,23.151,121.136Z",
    transform: "translate(26.209 137.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M49.912,172.16,60.869,203.6H55.4L36.2,172.16Z",
    transform: "translate(41.033 195.55)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M18.987,172.16,8.03,203.6H13.5l19.2-31.44Z",
    transform: "translate(9.035 195.55)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 87.634,
    height: 87.634,
    transform: "translate(89.578 368.5) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 87.634,
    height: 87.634,
    transform: "translate(117.024 368.5) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M92.568,210.448H16.51V134.39H92.568Zm-75.012-1.132H91.436V135.522H17.557Z",
    transform: "translate(18.668 152.649)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M91.417,145.707c-24.733-.726-49.744-.555-74.478,0a.3.3,0,1,0,0,.6c24.733.491,49.744.684,74.478,0a.256.256,0,1,0,0-.513Z",
    transform: "translate(18.815 164.955)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M33.32,141.546a2.136,2.136,0,1,0,2.136-2.136A2.136,2.136,0,0,0,33.32,141.546Z",
    transform: "translate(37.761 158.351)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M47.7,157.566a2.136,2.136,0,1,0,2.136-2.136A2.136,2.136,0,0,0,47.7,157.566Z",
    transform: "translate(54.095 176.547)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 123.56,
    height: 158.652,
    transform: "translate(248.529 155.256)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 106.259,
    height: 140.689,
    rx: 0.34,
    transform: "translate(256.688 165.145)",
    fill: "#f0edfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M133.37,146.97l-5.446,100.087H125.51l5.3-100.087Z",
    transform: "translate(142.477 166.938)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M127.827,146.97,122.21,247.057h7.048l5.3-100.087Z",
    transform: "translate(138.728 166.938)",
    fill: "#d9d9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M162.81,146.97l3.033,100.087h6.408L168.726,146.97Z",
    transform: "translate(184.844 166.938)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M168.143,146.97l3.2,100.087H169.1L165.58,146.97Z",
    transform: "translate(187.991 166.938)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 69.544,
    height: 5.126,
    transform: "translate(285.8 186.055)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 88.211,
    height: 7.176,
    transform: "translate(267.111 197.824)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 88.211,
    height: 7.176,
    transform: "translate(267.111 237.081)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 88.211,
    height: 7.176,
    transform: "translate(267.111 249.832)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 88.211,
    height: 7.176,
    transform: "translate(267.111 261.857)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 42.376,
    height: 5.98,
    transform: "translate(278.196 210.062)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 42.376,
    height: 5.98,
    transform: "translate(312.562 275.761)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 42.376,
    height: 5.98,
    transform: "translate(312.562 284.347)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 87.335,
    height: 9.74,
    transform: "translate(267.987 221.574)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M66.22,119.5Z",
    transform: "translate(75.131 135.736)",
    fill: "#111f49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M66.22,119.72Z",
    transform: "translate(75.131 135.986)",
    fill: "#66eafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M209.394,125.725s-26.7,0-36.673-4.934-16.937-17.087-21.508-25.63c-4.272-8.138-9.27-17.92-44.255-17.535h-.47l-4.806.128H95.937c-6.408.235-16.553,1.068-24.178,4.272C60.7,86.6,56.381,96.977,53.135,114.064s.192,32.743,28,40.581l.6.171a4,4,0,0,1,0,.449c0,1.73.427,7.967.47,11.939h0v.47a67.964,67.964,0,0,0,25.63,2.136h.982a165.1,165.1,0,0,0,27.168-4.443,194.594,194.594,0,0,1-3.353-24.285c-1.217-14.652-3.012-31.718-3.14-35.69s.491-6.408,2.648-5.532,3.845,14.182,10.1,23.2,21.081,17.792,42.931,18.155,29-6.109,29-6.109a27.489,27.489,0,0,0-4.784-9.376ZM70.435,122.949c-.6-6.6,2.136-18.262,3.845-18.262s1.922,4.08,2.648,9.74c.662,5.169,1.623,15.186,1.773,18.3v.683h0C78.21,133.137,71.076,129.335,70.435,122.949Z",
    transform: "translate(59.126 88.16)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M71.707,191.435c-1.815.7-7.326,2.713-7.155,4.72S75.936,196.8,82.3,192.5a16.232,16.232,0,0,0-10.594-1.068Z",
    transform: "translate(73.232 216.942)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M140.722,173.947c-8.052-22.106-20.205-55.3-20.205-55.3a165.1,165.1,0,0,1-27.168,4.443A68.561,68.561,0,0,1,66.8,120.957c0,4.272-1.132,34.58-1.089,51.773,0,16.1,1.089,45.43,2.136,61.342.854,14.268,2.285,39.642,2.285,39.642h.342a16.232,16.232,0,0,1,10.679,1.068s3.8-45.9,5.468-67.814,4.571-46.241,5.425-52.265,2.883-12.537,5.767-9.526,13.926,25.481,18.731,34.985,9.376,20.184,8.309,26.186-6.728,30.393-7.817,43.337a75.609,75.609,0,0,0,1.2,23.494s11.3-.256,11.512-.214,10.466-39.77,13.969-52.03C147.685,207.117,148.774,196.054,140.722,173.947Z",
    transform: "translate(74.551 134.77)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M101.812,190.9c0,.235-11.384.3-11.512.214,0,.406.449,4.379,9.483,5.511s9.441-.833,9.441-1.388C109.224,194.125,105.678,192.31,101.812,190.9Z",
    transform: "translate(102.483 216.836)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M73.77,76.193A41.243,41.243,0,0,0,75.244,80.7c.513.854,2.713.449,2.862,0s0-3.417,0-4.549h0A6.771,6.771,0,0,1,73.77,76.193Z",
    transform: "translate(83.707 86.496)",
    fill: "#f4a188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M91.3,78.481a22.728,22.728,0,0,1-1.623,3.845A14.223,14.223,0,0,1,88.5,84.163a11.341,11.341,0,0,1-5.361,4.144,6.557,6.557,0,0,1-4.421,0,6.173,6.173,0,0,1-3.375-3.118,27.617,27.617,0,0,1-2.99-7.006,3.524,3.524,0,0,1-2.9-3.481,2.691,2.691,0,0,1,.726-2.435,5.19,5.19,0,0,0,1.068,2.627c1.175,1.089,1.986-1.773,2.713-3.417s5.7-4.015,12.281-4.806a24.82,24.82,0,0,0,5.425-1.26A22.064,22.064,0,0,1,91.3,78.481Z",
    transform: "translate(78.737 74.297)",
    fill: "#f4a188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M70.139,69.522a14.118,14.118,0,0,1,16.19-7.732,5.767,5.767,0,0,0,4.7-.427c1.452-.9,3.887-.15,4.507,3.567.427,2.52-1.047,4.272-4.079,5.446a23.067,23.067,0,0,1-5.4,1.217c-6.6.833-11.534,3.268-12.26,4.912s-1.559,4.528-2.755,3.417A5.831,5.831,0,0,1,69.968,77.3a15.613,15.613,0,0,1,.171-7.775Z",
    transform: "translate(78.923 69.309)",
    fill: "#000170"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 24.434,
    height: 36.096,
    transform: "translate(173.394 222.563) rotate(-3.23)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M79.9,110.848l5.233-.7c3.033-.427,2.9.918,2.136,1.645a13.307,13.307,0,0,1-3.481,1.367s7.155-1.132,7.283.47-7.283,2.349-7.283,2.349,7.3-.427,7.283,1.025-7.411,1.559-7.411,1.559,4.571-.128,4.571,1.239-7.112,1.516-8.244,1.431a36.14,36.14,0,0,1,0-10.081Z",
    transform: "translate(90.368 125.015)",
    fill: "#f4a188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M125.76,103.488a11.619,11.619,0,0,1,4.272-4.272c2.969-1.687,6.664-2.734,6.749-1.452s-3.78,4.015-3.78,4.015a10.893,10.893,0,0,1,3.012,6.9,39,39,0,0,1-5.446,4.08A25.2,25.2,0,0,0,125.76,103.488Z",
    transform: "translate(142.761 110.398)",
    fill: "#f4a188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M129.155,102.769c.534,1.089,5.361-1.815,5.041-3.246S128.429,101.273,129.155,102.769Z",
    transform: "translate(146.542 112.633)",
    fill: "#f4a795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M129.626,103.875c.534,1.111,6.215-2.52,5-3.716S128.963,102.529,129.626,103.875Z",
    transform: "translate(147.075 113.492)",
    fill: "#f4a795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M130.035,104.51c.449.961,5.852-2.136,4.72-3.417S129.394,103.144,130.035,104.51Z",
    transform: "translate(147.542 114.501)",
    fill: "#f4a795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M151.761,91.063a.406.406,0,0,1,0,.577l-22.726,19.009a.406.406,0,0,1-.577,0h0a.406.406,0,0,1,0-.555l22.747-19.031a.384.384,0,0,1,.555,0Z",
    transform: "translate(145.701 103.301)",
    fill: "#99a6ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M128.785,101.5c.812,1.452,5.1-1.431,4.656-2.713S127.995,100.067,128.785,101.5Z",
    transform: "translate(146.1 111.811)",
    fill: "#f4a795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M63.11,90.87s8.159,32.914,35.925,42.311a63.9,63.9,0,0,1-32.764-14.823Z",
    transform: "translate(71.599 103.216)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M66,113.7s.534,9.74.491,12.815a67.75,67.75,0,0,0,33.96,1.367l-.619-10.807H95.368S77.085,118.292,66,113.7Z",
    transform: "translate(74.881 129.148)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    transform: "translate(389.55 342.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M183.14,257.607h-.128a.7.7,0,0,1-.577-.812l15.805-95.772a.7.7,0,0,1,.812-.6.726.726,0,0,1,.6.812L183.823,257.03A.683.683,0,0,1,183.14,257.607Z",
    transform: "translate(-182.425 -160.416)",
    fill: "#d39e7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    transform: "translate(470.111 342.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M236.646,257.618a.683.683,0,0,1-.683-.6l-15.805-95.793a.683.683,0,0,1,.577-.812.7.7,0,0,1,.812.6l15.805,95.772a.7.7,0,0,1-.577.812Z",
    transform: "translate(-220.144 -160.406)",
    fill: "#d39e7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(142.41 349.528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M67.323,253.936h0a.7.7,0,0,1-.6-.812L80.2,164.251a.726.726,0,0,1,.812-.6.7.7,0,0,1,.6.812L68.135,253.338a.7.7,0,0,1-.812.6Z",
    transform: "translate(-66.716 -163.647)",
    fill: "#d39e7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(210.928 349.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M112.987,253.972a.7.7,0,0,1-.7-.619L98.805,164.436a.7.7,0,1,1,1.388-.214L113.671,253.1a.683.683,0,0,1-.577.812Z",
    transform: "translate(-98.795 -163.616)",
    fill: "#d39e7a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M186.4,198.943H250.75s26.72-1.3,26.72-24.605c0-22.811-16.446-43.828-16.446-43.828L183.94,194.436Z",
    transform: "translate(208.845 148.241)",
    fill: "#d39e7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M62.3,143.7s14.652,42.589,22,47.544,61.321,1.858,61.321,1.858L147.756,187,130.669,142.38Z",
    transform: "translate(70.679 161.724)",
    fill: "#d39e7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M162.362,116.717c-3.674-8.244-18.753-8.394-40.752-8.928a7.134,7.134,0,0,1,0,1.986c-.32.555-2.136.384-2.606,0a6.408,6.408,0,0,1-.662-2.136c-8.373,0-31.782,2.136-39.663,7.091-8.266,5.212-13.37,24.007-16.446,35.242s-5.66,21.359-.235,29.368c3.994,5.895,17.749,8.949,23.067,9.782,0,0-.6,7.091-.47,10.039a247.34,247.34,0,0,0,34.879,2.606,106.666,106.666,0,0,0,27.553-3.182,119.862,119.862,0,0,1-1.538-17.92v-.3h.918l2.136-.363c5.6-1.068,17.087-4.272,19.906-13.477C172.379,154.2,166.142,125.218,162.362,116.717ZM86.2,172.485a9.035,9.035,0,0,1-5.425-10.423c1.645-6.408,7.86-26.656,11.555-28.279.7-.3-.555,7.86-2.456,18.005-1.367,7.241-2.99,18.454-3.567,20.376a1.322,1.322,0,0,1,0,.214Zm58.266-9.654-.7.427v-.214c-.256-2.67-2.8-30.564-1-30.885s6.408,2.136,7.8,15.25c1.175,11.192-3.546,13.9-6.087,15.357Z",
    transform: "translate(66.752 122.264)",
    fill: "#1c468a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M216.161,98.334c-1.367-4.571-4.955-10.978-11.021-9.569s-10.06,4.037-11.491,2.648-3.118-1.047-4.272.854-.491,6.408,2.99,9.654a12.2,12.2,0,0,0,2.99,2.008,11.683,11.683,0,0,0,11.192,0c1.516-.641,3.738.513,4.272,4.485.79,5.147-1.388,11.3-.256,11.726s5.489-.449,6.664-7.625a26.934,26.934,0,0,0-1.068-14.182Z",
    transform: "translate(214.429 100.6)",
    fill: "#1f1433"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M292.527,184.592a44.534,44.534,0,0,1-16.318,9.932,33.042,33.042,0,0,1-25.993-1.517l-.9-2.029-8.736-20.227h-.107a91.841,91.841,0,0,1-30.885,11.171c-16.3,2.136-44-2.734-44-2.734s-3.033-8.543-3.033-8.842,19.116-2.734,22.9-3.439l.256-.107a2.137,2.137,0,0,1,.427-.256c3.033-1.623,15.4-8.778,21.209-19.522,6.621-12.3,9.569-23.495,13.007-27.3s21.359-12.068,31.077-14.8,19.095,5.4,18.945,15.378v.384c1.111,2.713,9.675,24.2,14.332,37.826C289.708,173.037,292.527,184.592,292.527,184.592Z",
    transform: "translate(184.56 118.572)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M161.654,200.153a4.89,4.89,0,0,0-1.431-.513c-3.524,1.794-9.718,4.144-8.992,6.279s9.633,1.858,17.322-5.724a21.357,21.357,0,0,1-6.9-.043Z",
    transform: "translate(171.626 226.764)",
    fill: "#111f49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M191.863,205.283l-.278-.6h0s-7.411,6.621-5.874,9.7,8.031-.94,10.679-4.848a17.855,17.855,0,0,0,2.349-9.334,11.171,11.171,0,0,1-6.877,5.083Z",
    transform: "translate(210.619 227.4)",
    fill: "#111f49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M281.59,172.027c-6.621,11.726-22,11.6-44.127,12.431a157.348,157.348,0,0,1-38.189-2.969,128.536,128.536,0,0,1,14.951,41.158,222.131,222.131,0,0,1,1.666,43.764,11.213,11.213,0,0,1-6.856,5.083,1.1,1.1,0,0,0-.278-.577c-1.431-3.247-8.543-19.031-12.6-29.71-4.485-11.534-16.638-41.948-17.471-43.977a.3.3,0,0,0,0-.128v.128L171.593,186l-1.153-14.737,4.443-8.543,18.069-2.5,52.542-8.223,1.452.47a2.735,2.735,0,0,1,.491.128,33.6,33.6,0,0,0,19.949-.769A44.533,44.533,0,0,0,283.7,141.89C285.05,147.593,288.211,160.365,281.59,172.027Z",
    transform: "translate(193.511 161.168)",
    fill: "#1c468a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M92.25,204.835s.6,4.272,7.219,5.681,13.712.235,14.182-1.3-9.7-5.083-9.7-5.083C101.712,206.736,92.25,204.835,92.25,204.835Z",
    transform: "translate(104.698 231.864)",
    fill: "#111f49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M141.281,185.267c.47-13.84,5.083-25.63,8.159-29.582L133.7,150.26a106.667,106.667,0,0,1-27.553,3.182,247.323,247.323,0,0,1-34.879-2.606c-.128,2.008-2.948,16.083,3.439,24.84s25.289,6.514,35.947,5.553,26.634-3.033,26.164.128c-1.239,8.2-7.561,20.974-12.452,38.937-3.909,14.332-7.454,38.616-7.454,45.729,0,0,9.462,1.9,11.7-.7l14.4-37.976.278-.7S140.811,199.086,141.281,185.267Z",
    transform: "translate(80.037 170.675)",
    fill: "#b5453c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M106.7,197.874a25.63,25.63,0,0,0,7.817,8.992c4.592,2.712,6.621.7,5.895-2.136s-7.924-10.06-7.839-10.38h0l-.192.683a7.262,7.262,0,0,1-5.681,2.841Z",
    transform: "translate(121.111 220.755)",
    fill: "#111f49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M130.973,149.33c-4.848-2.349-30.863,2.734-30.863,2.734l14.075,6.408c-3.076,4.015-7.71,17.45-8.2,31.29s3.182,38.446,3.182,38.446l.256,1.047c2.136,11.534,4.763,20.59,4.763,20.59a7.262,7.262,0,0,0,5.681-2.948l.192-.683c1.751-5.959,14.524-50.107,16.831-68.625C139.367,157.574,135.822,151.658,130.973,149.33Z",
    transform: "translate(113.626 168.914)",
    fill: "#9e332e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M83.7,101.771a4.272,4.272,0,0,0-.491-.641A2.434,2.434,0,0,0,83.7,101.771Z",
    transform: "translate(94.43 114.87)",
    fill: "#f4a188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M83.44,101.43Z",
    transform: "translate(94.691 115.211)",
    fill: "#f4a188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M264.382,149.294,194.6,161.084s-13.285.854,1.047,32.764c0,0-2.67,33.17-32.038,68.711,0,0-6.749,1.153-8.2-.726l25.63-89.3s2.136-15.613,21.359-18.539l55.191-9.013Z",
    transform: "translate(176.439 164.677)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M90.524,110.834a8.753,8.753,0,0,0-.171-2.136,21.552,21.552,0,0,1-4.144-3.738,48.677,48.677,0,0,0,1,5.9,6.408,6.408,0,0,0,.662,2.136c.555.406,2.285.555,2.606,0a7.133,7.133,0,0,0,.043-2.157Z",
    transform: "translate(97.837 119.22)",
    fill: "#f4a188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M107.774,108.59a23.857,23.857,0,0,1-.491,6.408,8.543,8.543,0,0,1-7.091,7.155,9.4,9.4,0,0,1-7.07-1.709,15.677,15.677,0,0,1-3.311-2.99,20.547,20.547,0,0,1-2.136-2.883c-4.635,1.88-6.856-5.019-5.318-6.066h.192c.577-.192,1.538.491,2.136,1.26a1.965,1.965,0,0,0,.491.662l.171.256a8.223,8.223,0,0,1,1.687-5.916c2.136-1.986,4.827-1.217,10.466-3.5,5.19-2.136,6.408-4.464,7.006-7.6a37.014,37.014,0,0,1,3.1,13.541A3.387,3.387,0,0,1,107.774,108.59Z",
    transform: "translate(92.911 106.385)",
    fill: "#f4a188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M82.19,100.611c.577-.192,1.516.513,2.136,1.26a2.842,2.842,0,0,1-.235-.513C83.642,100.739,82.98,100.226,82.19,100.611Z",
    transform: "translate(93.271 114.129)",
    fill: "#1f1433"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M83.1,100.89a2.841,2.841,0,0,0,.235.513,4.272,4.272,0,0,1,.491.641,12.81,12.81,0,0,0-.726-1.153Z",
    transform: "translate(94.305 114.597)",
    fill: "#1f1433"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M96.161,89.561c-7.646.513-13.862,5.7-15.271,11.064s2.926,12.538,2.926,12.538h.171c.79-.384,1.452.128,1.944.748a12.812,12.812,0,0,1,.726,1.153h0l.171.278a8.18,8.18,0,0,1,1.709-5.916c2.136-1.986,4.784-1.239,10.444-3.5,5.19-2.136,6.408-4.464,7.006-7.6a6.257,6.257,0,0,1,.15-.876C106.8,93.747,103.786,89.048,96.161,89.561Z",
    transform: "translate(91.474 101.685)",
    fill: "#1f1433"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M196,107a31.635,31.635,0,0,0,3.5,5.382c.577.128,2.841-.128,3.054-1.773a20.611,20.611,0,0,0-1.88-5.916A9.056,9.056,0,0,1,196,107Z",
    transform: "translate(222.544 118.913)",
    fill: "#f4a188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M208.95,112.993a7.369,7.369,0,0,1-1.815,2.883,9.334,9.334,0,0,1-4.656,2.307,8.543,8.543,0,0,1-9.312-4.122h0a24.349,24.349,0,0,1-1.88-5.126,34.345,34.345,0,0,1-.577-14.075,13.326,13.326,0,0,0,2.969,1.986,11.747,11.747,0,0,0,11.213,0c1.5-.641,3.716.491,4.272,4.485C210,106.415,207.818,112.566,208.95,112.993Z",
    transform: "translate(216.001 107.748)",
    fill: "#f4a188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M85.679,138.8s-6.408,2.349-6.408,2.99,5.041-.7,5.041-.7-7.241,3.14-6.771,4.443,6.771-2.136,6.771-2.136-6.408,3.631-6.066,4.891,7.112-2.648,7.112-2.648-3.866,2.414-3.7,3.5,4.806-2.627,4.806-2.627-2.136,2.414-1.26,2.841,8.672-4.784,8.672-4.784-3.076-1.965-4.891-3.375A27.886,27.886,0,0,0,85.679,138.8Z",
    transform: "translate(87.966 157.658)",
    fill: "#f4a188"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 6.258,
    height: 124.393,
    transform: "translate(196.264 320.401)",
    fill: "#f9ddbf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 6.258,
    height: 124.393,
    transform: "translate(393.618 320.401)",
    fill: "#f9ddbf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    width: 203.612,
    height: 10.017,
    transform: "translate(196.264 312.584)",
    fill: "#f9ddbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M93.725,142.561c.235,0,7.732-.7,8.543.47s-3.951,1.73-3.951,1.73,7.732,3.012,7.176,4.272-6.685-1.794-6.685-1.794,7.134,3.46,6.728,4.955-7.839-1.666-7.839-1.666,4.421,2.542,4.1,3.481-5.361-.79-5.361-.79,2.606,1.26,1.965,2.136-7.241-1.815-8.992-2.136c0,0-.555-1.41,1.025-5.361a14.054,14.054,0,0,1,3.289-5.3Z",
    transform: "translate(101.365 161.692)",
    fill: "#f4a188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M168.322,127.17H150.21l12.644,31.461,17.3-1.3Z",
    transform: "translate(170.532 144.448)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M168.037,137.825v-.235s-2.414-4.421-3.289-4.1.876,3.7.876,3.7-5.831-1.346-6.066-.214,4.4,2.136,4.4,2.136-5.98-.406-6.066.235c-.171,1.239,6.536,1.88,6.536,1.88s-4.165.171-4.272,1.025,5.916,1.581,5.916,1.581-4.1,0-3.887.726,5.361,1.751,8.693,1.516Z",
    transform: "translate(179.254 151.606)",
    fill: "#f4a188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M228.9,111.73l.427,1.111s8.778,42.1-24.263,63.328L199,162.393S227.621,142.081,228.9,111.73Z",
    transform: "translate(225.951 126.91)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M220.249,142.425a107.669,107.669,0,0,1-46.989,16.3l.256-.107a2.135,2.135,0,0,1,.427-.256c3.033-1.623,15.4-8.778,21.209-19.522,6.621-12.3,9.569-23.494,13.007-27.3Z",
    transform: "translate(196.714 126.694)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M86.4,158.422l.641-.278h0l5.212-2.136A47.309,47.309,0,0,1,76.964,123.65s-4.635,27.531-5.254,30.265a97.866,97.866,0,0,0,14.5,4.656Z",
    transform: "translate(81.367 140.449)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M71.329,145.92s36.566,3.781,39,3.311l5.511,1.581v7.155s-8.543,2.947-44.96-2.136Z",
    transform: "translate(80.424 165.745)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M106.058,141.76l.961,9.8H99.906a34.34,34.34,0,0,0-5.895-3.588s6.13,3.225,6.685,1.794c0,0,1.047-1.047-7.176-4.272,0,0,3.887-.47,4.037-1.452,0,0,0-.812-2.136-.876Z",
    transform: "translate(106.14 161.02)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M87.94,143.338l22.768-6.792-.491-5.446S92.34,142.014,87.94,143.338Z",
    transform: "translate(99.802 148.912)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M204.126,197.805s18.582,1.687,26.25-3.182-7.668-9.4-23.494-7.134S186.462,198.211,204.126,197.805Z",
    transform: "translate(218.903 212.28)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    width: 2.093,
    height: 18.753,
    transform: "translate(402.589 121.637)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    width: 2.093,
    height: 18.753,
    transform: "translate(471.641 121.637)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 87.827,
    height: 7.54,
    transform: "translate(394.835 114.098)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    width: 12.11,
    height: 56.429,
    transform: "translate(453.209 57.668)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M218.866,48.307A2.414,2.414,0,1,1,216.474,46a2.414,2.414,0,0,1,2.392,2.307Z",
    transform: "translate(243.036 52.25)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 3.695,
    height: 23.067,
    transform: "translate(457.544 72.619)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 12.11,
    height: 56.429,
    transform: "translate(440.906 57.668)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M213.084,48.307A2.392,2.392,0,1,1,210.691,46a2.392,2.392,0,0,1,2.392,2.307Z",
    transform: "translate(236.515 52.25)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 3.695,
    height: 23.067,
    transform: "translate(445.242 72.619)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 12.11,
    height: 56.429,
    transform: "translate(429.202 57.668)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M207.626,48.307A2.414,2.414,0,1,1,205.234,46a2.414,2.414,0,0,1,2.392,2.307Z",
    transform: "translate(230.269 52.25)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_231",
    "data-name": "Rectangle 231",
    width: 3.695,
    height: 23.067,
    transform: "translate(433.537 72.619)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M196.854,80.587,211.4,30.95l-5.019-2.2L191.45,78.793Z",
    transform: "translate(217.375 32.656)",
    fill: "#e0e0e0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessOffer);
export default __webpack_public_path__ + "static/media/business-offer.e12e940e3acb0a481f491e5cfe0e4473.svg";
export { ForwardRef as ReactComponent };